<template>
  <div>
    <select class="contractor__contr-select"
            :multiple="multiple"
            :class="{'hide-dropdown': absoluteDropdown}">
      <slot></slot>
    </select>
  </div>
</template>

<script>
  import $ from 'jquery'
  import 'selectric'
  import arrow from '@/assets/img/static/vector-arrow.svg';

  export default {
    name: "Selectric",

    props: [
      'value',
      'disabled',
      'options',
      'multiple',
      'absoluteDropdown'
    ],

    watch: {
      'value': function() {
        this._setValues(true);
      },

      'options': function(options) {
        this.select.empty();

        for (let item of options) {
          if (item.id) {
            this.select.append(`<option value="${item.id}" ${item.disabled ? 'disabled' : ''}>${item.name}</option>`)
          }
          else {
            this.select.append(`<option value ${item.disabled ? 'disabled' : ''}>${item.name}</option>`)
          }
        }

        this._setValues(true);
      },

      'disabled': function() {
        this.select.prop('disabled', this.disabled).selectric('refresh');
      }
    },

    updated() {
      this.select.selectric('refresh');
    },

    mounted() {
      this.select = $(this.$el).find('select');

      if (this.disabled) {
        this.select.prop('disabled', 'disabled');
      }

      if (this.options) {
        for (let item of this.options) {
          if (item.id) {
            this.select.append(`<option value="${item.id}" ${item.disabled ? 'disabled' : ''}>${item.name}</option>`)
          }
          else {
            this.select.append(`<option value ${item.disabled ? 'disabled' : ''}>${item.name}</option>`)
          }
        }
      }

      if (this.value) {
        this._setValues(false);
      }

      const vm = this;
      const elem = this.select;

      const s = this.select.selectric({
        maximumSelectionLength: this.maxSelected,
        arrowButtonMarkup: `<b class="button"><img class="selectric-img-button" src="${arrow}" alt=""></b>`,
      })
        .trigger('change')
        .on('change', function() {
          if (this.multiple) {
            const data = elem.find(':selected').toArray().map(e => e.value);

            vm.$emit('input', data);
            vm.$emit('change', data);
          }
          else {
            vm.$emit('input', this.value);
            vm.$emit('change', this.value);
          }
        });

      if (this.absoluteDropdown) {
        s.on('selectric-open', function(event, dom, elem) {
          const dropdown = elem.elements.items;
          const offset = dropdown.offset();

          vm.dp = dropdown
            .clone()
            .appendTo('body')
            .offset({
              top: offset.top - 108,
              left: offset.left
            })
            .css({
              'display': 'block',
              'position': 'absolute',
              'z-index': 9999
            });
        })
          .on('selectric-close', function() {
            vm.dp.remove();
          })
      }
    },

    beforeDestroy() {
      this.select.off().selectric('destroy');
    },

    methods: {
      _setValues(doRefresh) {
        if (this.multiple) {
          $(this.select).val(this.value || []);
        }
        else {
          this.select.val(this.value + '');
        }

        if (doRefresh) {
          this.select.selectric('refresh');
        }
      }
    }
  }
</script>

<style lang="scss">
  $selectric-border-width: 1px;
  $selectric-main-color: #e4e4e4;
  $selectric-bg-color: #fff;
  $selectric-btn-bg-color: #fff;
  $selectric-border-radius: 5px;
  $selectric-font-size: 18px;
  $selectric-height: 36px;
  //$selectric-inner-height: 30px;
  $selectric-spacing: 0;
  $selectric-text-color: #666;

  @import '../../../node_modules/selectric/src/selectric';

  .selectric-wrapper {
    margin: 0;
    /*max-width: 480px;*/
  }

  .selectric {
    .label {
      line-height: inherit;
    }

    .button {
      &:after {
        border: none;
      }

      .selectric-img-button {
        position: relative;
        top: 14px;
        z-index: 10;
      }
    }
  }

  .selectric-hide-dropdown {
    .selectric-items {
      visibility: hidden !important;
    }
  }

  .selectric-items {
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;

    ul, li {
      font-size: 16px;
    }

    li {
      padding: 5px 0 5px 0;
      border-top: 1px solid #fff;
      border-bottom: 1px solid #eee;
      color: #333;

      &.selected,
      &:hover{
        background: #f5f5f5;
        color: #333;
      }

      &.selected {
        border-top-color: #e4e4e4;

        &:before {
          position: absolute;
          right: 14px;
          width: 14px;
          height: 14px;
          content: "";
          background: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSItMS40IC0xLjcgMTQgMTQiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgLTEuNCAtMS43IDE0IDE0IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCgk8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0UzMDYxMyIgZD0iTTEwLjYtMC43TDMsOC44TDAuNCw2LjVjMCwwLTEuNCwwLjEtMSwwLjVsMi45LDMuOWMwLjIsMC4yLDAuNCwwLjMsMC42LDAuM2MwLDAsMC4xLDAsMC4xLDAgYzAsMCwwLjEsMCwwLjEsMGMwLjQsMCwwLjctMC4yLDAuOS0wLjVsOC0xMUMxMi4yLTAuOCwxMC42LTAuNywxMC42LTAuN3oiLz4NCjwvc3ZnPg0K) no-repeat 0 0;
        }
      }
    }
  }
</style>
